const SUBS = {
  estate: "REAL ESTATE",
  rent: "RENT",
  ready: "READY",
  construction: "RISTRUTTURA",
};

/* Family wordmarks for the IDEAL GROUP companies, mirroring the official
   logo design: serif IDEAL with the beige swoosh + letterspaced sub-label. */
export const GroupMark = ({ company, className = "h-12 w-auto", tone = "ink" }) => {
  const ink = tone === "ink" ? "#181C20" : "#FBF9F5";
  const tan = tone === "ink" ? "#B99B6B" : "#D9BC8C";
  return (
    <svg viewBox="0 0 176 54" fill="none" className={className} aria-hidden="true">
      <text x="2" y="30" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="33" fontWeight="600" letterSpacing="5" fill={ink}>
        IDEAL
      </text>
      <path d="M58 25 C 76 15, 94 19, 116 11" stroke={tan} strokeWidth="1.6" strokeLinecap="round" />
      <line x1="4" y1="43" x2="30" y2="43" stroke={tan} strokeWidth="0.9" />
      <text x="38" y="47" fontFamily="Outfit, sans-serif" fontSize="10.5" fontWeight="500" letterSpacing="5" fill={tan}>
        {SUBS[company] || ""}
      </text>
    </svg>
  );
};

export default GroupMark;
